export const environment = {
  production: true,
  serverUrl: 'https://api.test.btregistration.si.siemens.cloud',
  recaptcha: {
    siteKey: '6LcdNKcoAAAAAMpcgAeBQKfQld8y0LBU5tvxG_Yu'
  }
};
